// src/components/home/Home.js
import React from 'react';
import Hero from './Hero';
import Ceremony from "./Ceremony";
import Reception from "./Reception";
import Join from "./Join";
import Album from "./Album";
import EventVideos from "./EventVideos";

const Home = () => {
    return (
        <div>
            <Hero />
            {/* The videos the hero slides scroll down to. Directly under the
                hero so the click lands somewhere visible. */}
            <EventVideos />
            <Ceremony />
            <Reception />
            <Album />
            <Join />
        </div>
    );
};

export default Home;
